import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '../../environments/environment';
import {Observable} from 'rxjs';
import {Berater} from '../shared/model/berater.model';
import {Photos} from '../shared/model/personaldaten.model';

@Injectable({providedIn: 'root'})
export class ImageService {
  constructor(private http: HttpClient) {
  }

  getThumbnail(userId: string, photoId: string) {
    const url = `${environment.apiConfig.uri}api/berater/${userId}/photos/${photoId}/thumbnail`;
    return this.http.get(url, {responseType: 'blob'});
  }

  deletePhoto(userId: string, photoId: string) {
    const url = `${environment.apiConfig.uri}api/berater/${userId}/photos/${photoId}`;
    return this.http.delete(url);
  }

  uploadPhoto(consultantId: string, file: File): Observable<Berater> {
    const formData = new FormData();
    formData.append('file', file, file.name);

    return this.http.post<Berater>(
      `${environment.apiConfig.uri}api/berater/${consultantId}/photos`,
      formData
    );
  }

  reorderPhotos(consultantId: string, photoIds: string[]): Observable<any> {
    return this.http.put(
      `${environment.apiConfig.uri}api/berater/${consultantId}/photos/order`,
      {photoIds}
    );
  }

  replacePhoto(consultantId: string, photoId: string, file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.http.post<Photos>(
      `${environment.apiConfig.uri}api/berater/${consultantId}/photos/${photoId}`,
      formData
    );
  }

  getOriginalPhoto(userId: string, photoId: string) {
    const url = `${environment.apiConfig.uri}api/berater/${userId}/photos/${photoId}/original`;
    return this.http.get(url, {responseType: 'blob'});
  }
}
